type SoundName = 'game-start' | 'hand-bet' | 'hand-check' | 'hand-fold' | 'hand-timeout'

const SOUND_FILES: Record<SoundName, string> = {
  'game-start': '/sounds/game-start.aac',
  'hand-bet': '/sounds/hand-bet.aac',
  'hand-check': '/sounds/hand-check.aac',
  'hand-fold': '/sounds/hand-fold.aac',
  'hand-timeout': '/sounds/hand-timeout.aac',
}

const audioCache = new Map<SoundName, HTMLAudioElement>()

function getAudio(name: SoundName): HTMLAudioElement {
  let audio = audioCache.get(name)
  if (!audio) {
    audio = new Audio(SOUND_FILES[name])
    audioCache.set(name, audio)
  }
  return audio
}

export function playSound(name: SoundName): void {
  const audio = getAudio(name)
  audio.currentTime = 0
  audio.play().catch((error) => {
    console.error(`Error playing ${name} sound:`, error)
  })
}
